import React from 'react';
import { Helptip } from 'library';

import './InterestLabel.scss';

const InterestRateLabel = ({ interestRateStat, interestRateSource }) => {
  return (
    <>
      <span className={interestRateStat ? 'InterestRateLabelTitle' : ''}>
        Interest rate
        {interestRateSource && <Helptip text={interestRateSource} iconSize="sm" action="hover-in-click-out" />}
      </span>
      {interestRateStat && <span className="InterestRateLabelSubText">{interestRateStat}</span>}
    </>
  );
};

export default InterestRateLabel;
